import {useMediaQuery} from "@mui/material";

export const useIsMobileShare = (query?: string) => {
	const isMobile = useMediaQuery(query || "(max-width: 768px)");
	const isMobileShare = "share" in navigator && isMobile;

	return {isMobileShare};
};
